import { Link, NavLink } from "react-router-dom";
import { useState, useRef } from "react";
import { motion, AnimatePresence, useSpring, useMotionValue } from "framer-motion";
import logo from "../assets/images/logo.png";
import "../styles/Navbar.css";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/netsuite", label: "NetSuite" },
  { to: "/salesforce", label: "Salesforce" },
  { to: "/web-development", label: "Web Dev" },
  { to: "/blog", label: "Insights" }, // Added Insights
  { to: "/contact", label: "Contact" },
];

const MagneticLink = ({ children, to, onClick }) => {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const springConfig = { damping: 15, stiffness: 150 };
  const springX = useSpring(x, springConfig);
  const springY = useSpring(y, springConfig);

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const { left, top, width, height } = ref.current.getBoundingClientRect();
    const centerX = left + width / 2;
    const centerY = top + height / 2;
    x.set((clientX - centerX) * 0.35);
    y.set((clientY - centerY) * 0.35);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ x: springX, y: springY }}
    >
      <NavLink 
        to={to} 
        onClick={onClick}
        className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}
      >
        {children}
      </NavLink>
    </motion.div>
  );
};

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="nav-container">
      <motion.nav 
        className="floating-nav"
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 80, damping: 20 }}
      >
        <Link to="/" className="nav-logo" onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="ITSeva Hub" className="logo-img-large" />
        </Link>

        <div className="nav-menu-desktop">
          {navLinks.map((link) => (
            <MagneticLink key={link.to} to={link.to}>
              {link.label}
            </MagneticLink>
          ))}
          <Link to="/contact" className="cta-pill">Get Started</Link>
        </div>

        <button 
          className={`menu-toggle ${menuOpen ? "open" : ""}`} 
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <div className="hamburger-box">
            <span className="line top"></span>
            <span className="line bottom"></span>
          </div>
        </button>
      </motion.nav>

      <AnimatePresence>
        {menuOpen && (
          <motion.div 
            className="mobile-overlay"
            initial={{ clipPath: "circle(0% at 90% 5%)" }}
            animate={{ clipPath: "circle(150% at 90% 5%)" }}
            exit={{ clipPath: "circle(0% at 90% 5%)" }}
            transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
          >
            <div className="mobile-links">
              {navLinks.map((link, i) => (
                <motion.div
                  key={link.to}
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.3 + i * 0.1 }}
                >
                  <NavLink to={link.to} onClick={() => setMenuOpen(false)}>
                    {link.label}
                  </NavLink>
                </motion.div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}